import DownloadAnalyticModal from "./DownloadAnalyticModal";

export default DownloadAnalyticModal;
